module.exports = __webpack_public_path__ + "media/god-rest-ye.b96e27b8.mp3";